import _ from 'lodash'
// Components
import BoundLink from './bound-link'
// Utils
import slugify from '../utils/slugify'
// Types
import type {ParentCategory} from '../types/ballot'
// Styles
import styles from './navbar-group-list.module.scss'

interface NavbarGroupListProps {
  groups: ParentCategory[]
  currentGroup: ParentCategory | null
}

const NavbarGroupList = ({
  groups,
  currentGroup,
}: NavbarGroupListProps) => {
  return !_.isEmpty(groups)
    ? (
      <div className={styles['navbar-group-list']}>
        {_.map(groups, group => {
          return (
            <BoundLink
              key={group._id}
              href={`/${slugify(group.parent_category_name)}`}
              shallow={true}
              className={styles['__group-link']}
              data-active={group.parent_category_name === currentGroup?.parent_category_name}
            >
              {group.parent_category_name}
            </BoundLink>
          )
        })}
      </div>
    )
    : null
}

export default NavbarGroupList
